module.exports = __webpack_public_path__ + "static/media/lux.4b6bdfbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/marcas/lux.png
// module id = 954
// module chunks = 0